/**
 * Arma el `title` de una celda con los valores de texto o número, separados por " · ".
 * @param {Array<*>} values Valores a mostrar (los que no son texto ni número se omiten).
 * @returns {string}
 */
export const buildCellTitle = (values) =>
  values.filter((value) => typeof value === 'string' || typeof value === 'number').join(' · ');
